import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userTaxValidation } from './validation'

export const useUserTaxForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userTaxValidation()),
    initialValues: {
      type_of_bussines: 'individual',
      id_type: 'NPWP',
      registered_vat: 'true',
      taxes_name: '',
      identity_card: '',
      taxes_address: '',
      taxes_id: '',
      company_name: '',
      company_country: null,
      new_company_logo: null,
      recent_company_logo: null
    },
    transformValues: (values) => {
      const payload = {
        type_of_bussines: values.type_of_bussines,
        registered_vat: values.id_type === 'KTP' ? null : values.registered_vat === 'true' ? true : false,
        taxes_name: values.taxes_name,
        taxes_address: values.taxes_address,
        taxes_id: values.id_type === 'NPWP' ? values.taxes_id : null,
        identity_card: values.id_type === 'KTP' ? values.identity_card : null,
      }

      if (values.type_of_bussines === 'business') {
        payload.company_name = values.company_name
        payload.company_country = values.company_country
        payload.new_company_logo = values.new_company_logo
      }
      return payload
    }
  })
}